import React from 'react';
import { CTAButton } from './CTAButton';
const moments = ['La próxima vez que llegues agotada a las 20:00 y abras la heladera sin saber qué cocinar.', 'La próxima vez que estés en el supermercado mirando una etiqueta sin entender nada.', 'La próxima vez que quieras comer una milanesa, un guiso o una pizza y sientas culpa antes de empezar.', 'La próxima vez que te preguntes si lo que estás comiendo está bien o está mal para tu tiroides.', 'La próxima vez que llegues a un cumpleaños, un viaje o una semana caótica sin saber cómo manejarte.'];
export function ClosingSection() {
  return <section className="bg-white py-20 sm:py-28" aria-labelledby="closing-title" data-id="element-33">
      <div className="mx-auto max-w-3xl px-5 text-center" data-id="element-34">
        <h2 id="closing-title" className="font-serif text-3xl font-semibold text-ink sm:text-4xl" data-id="element-35">
          Una última cosa.
        </h2>

        <div className="mt-8 space-y-4" data-id="element-36">
          {moments.map((m, i) => <p key={i} className="text-[17px] leading-relaxed text-ink/70" data-id="element-37">
              {m}
            </p>)}
        </div>

        <p className="mt-8 font-serif text-2xl font-semibold text-sage-deep" data-id="element-38">
          Lo vas a tener resuelto.
        </p>
        <p className="mt-3 font-serif text-xl italic text-ink" data-id="element-39">
          Mega Pack Tiroides.
        </p>

        <div className="mt-10" data-id="element-40">
          <CTAButton variant="coral" size="lg" data-id="element-41">
            Lo quiero resuelto ahora
          </CTAButton>
        </div>
      </div>
    </section>;
}